import { SEARCH_QUICK_LINKS } from 'commons/constants';

// Case-insensitive exact match: trim and collapse inner whitespace before comparing
const normalizeQuery = value =>
  value
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();

/**
 * Returns the SEARCH_QUICK_LINKS entry whose keywords exactly match
 * (case insensitive) the typed query, or null when there is no match.
 */
const getQuickLinkMatch = query => {
  const normalizedQuery = normalizeQuery(query || '');

  if (!normalizedQuery) {
    return null;
  }

  return (
    SEARCH_QUICK_LINKS.find(({ keywords }) =>
      keywords.some(keyword => normalizeQuery(keyword) === normalizedQuery)
    ) || null
  );
};

export default getQuickLinkMatch;
